import React, { useContext, useState, useEffect, useReducer } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import { Link } from 'react-router-dom';
import {apiRoutes} from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import Util from '../../../Util';
import ReactStars from "react-rating-stars-component";
import Reviews from './Review';

const DoctorProfile = (props) => {
   	const doctor = JSON.parse(props.location.state.selectedDoctor);
	const { userState } = useContext(AuthContext);
	const [profile, setProfile] = useState({});
	
	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer '+userState.token
		}
	};

	useEffect(() => {
		axios.get(apiRoutes.getDoctorProfile + doctor.doctorId, options)
		.then((response) => {
			if(response.status === 200)
			{
				const data = response.data;
				console.log(response.data);
				setProfile(response.data);
			}
		}, (error) => {
			console.log(error);
		});
	}, []);

	const loadVisitingHrs = (hrs) => {
		var visitingHr = Util.groupBy(hrs, 'visitingDayFromTo');
		console.log(visitingHr)
		return (
			Object.entries(visitingHr).map(item => (
				<div>
					<p className="timings-days">
						<span>{item[0]}</span>
					</p>
					<p className="timings-times">
						{
							item[1] != undefined &&
							item[1].map(h => (
								<span>{h.times}</span>
							))
						}
					</p>
				</div>
			))
		);
	}


    return (  
        <div>
            <Breadcrumb title="Doctor Profile"/>
            <div className="content">
				<div className="container">
					<div className="card">
						<div className="card-body">
							<div className="doctor-widget">
								<div className="doc-info-left">
									<div className="doctor-img">
										<img src={Util.loadImage(doctor.profileImage)} className="img-fluid" alt="User Image" />
									</div>
									<div className="doc-info-cont">
                                        <h4 className="doc-name">Dr. {doctor.firstName} {doctor.lastName}</h4>
										<p className="doc-speciality">{doctor.subTitle}</p>
										<p className="doc-department"><img src="assets/img/specialities/specialities-05.png" className="img-fluid" alt="Speciality" />{doctor.category}</p>
										<div className="rating">
											<ReactStars value={5} edit={false} size={20} />
											<span className="d-inline-block average-rating">(35)</span>
										</div>
										<div className="clinic-details">
											<p className="doc-location"><i className="fas fa-map-marker-alt"></i> {doctor.state}, {doctor.country} - <a href="javascript:void(0);">Get Directions</a></p>
											<ul className="clinic-gallery">
												<li>
													<a href="assets/img/features/feature-01.jpg" data-fancybox="gallery">
														<img src="assets/img/features/feature-01.jpg" alt="Feature" />
													</a>
												</li>
												<li>
													<a href="assets/img/features/feature-02.jpg" data-fancybox="gallery">
														<img  src="assets/img/features/feature-02.jpg" alt="Feature Image" />
													</a>
												</li>
												<li>
													<a href="assets/img/features/feature-03.jpg" data-fancybox="gallery">
														<img src="assets/img/features/feature-03.jpg" alt="Feature" />
													</a>
												</li>
												<li>
													<a href="assets/img/features/feature-04.jpg" data-fancybox="gallery">
														<img src="assets/img/features/feature-04.jpg" alt="Feature" />
													</a>
												</li>
											</ul>
										</div>
										<div className="clinic-services">
											<span>Dental Fillings</span>
											<span>Teeth Whitneing</span>
										</div>
									</div>
								</div>
								<div className="doc-info-right">
									<div className="clini-infos">
										<ul>
											<li><i className="far fa-thumbs-up"></i> 99%</li>
											<li><i className="far fa-comment"></i> 35 Feedback</li>
											<li><i className="fas fa-map-marker-alt"></i> Newyork, USA</li>
											<li><i className="far fa-money-bill-alt"></i> $100 per hour </li>
										</ul>
									</div>
									<div className="doctor-action">
										<a href="javascript:void(0)" className="btn btn-white fav-btn">
											<i className="far fa-bookmark"></i>
										</a>
										<Link className="btn btn-white msg-btn" to={
											{
												pathname: `/chat`,
												state: {
													receiver: JSON.stringify(doctor)
												}
											}
										}><i className="far fa-comment-alt"></i></Link>

										<Link className="btn btn-white call-btn" to={
											{
												pathname: `/voicecall`,
												state: {
													receiver: JSON.stringify(doctor)
												}
											}
										}><i className="fas fa-phone"></i></Link>

										<a href="javascript:void(0)" className="btn btn-white call-btn" data-toggle="modal" data-target="#video_call">
											<i className="fas fa-video"></i>
										</a>
									</div>
									<div className="clinic-booking">
										<Link className="apt-btn" to={
											{
												pathname: `/booking`,
												state: {
													selectedDoctor: JSON.stringify(doctor)
												}
											}
										}>Book Appointment</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="card-body pt-0">
							<nav className="user-tabs mb-4">
								<ul className="nav nav-tabs nav-tabs-bottom nav-justified">
									<li className="nav-item">
										<a className="nav-link active" href="#doc_overview" data-toggle="tab">Overview</a>
									</li>
									<li className="nav-item">
										<a className="nav-link" href="#doc_locations" data-toggle="tab">Locations</a>
									</li>
									<li className="nav-item">
										<a className="nav-link" href="#doc_reviews" data-toggle="tab">Reviews</a>
									</li>
									<li className="nav-item">
										<a className="nav-link" href="#doc_business_hours" data-toggle="tab">Business Hours</a>
									</li>
								</ul>
							</nav>
							<div className="tab-content pt-0">
								<div role="tabpanel" id="doc_overview" className="tab-pane fade show active">
									<div className="row">
										<div className="col-md-12 col-lg-9">
											<div className="widget about-widget">
												<h4 className="widget-title">About Me</h4>
												<p> {doctor.biography} </p>
											</div>
											{
												profile.doctorEducations != undefined &&
												<div className="widget education-widget">
													<h4 className="widget-title">Education</h4>
													<div className="experience-box">
														<ul className="experience-list">
															{
																profile.doctorEducations != undefined &&
																profile.doctorEducations.map(edu => (
																	<li>
																		<div className="experience-user">
																			<div className="before-circle"></div>
																		</div>
																		<div className="experience-content">
																			<div className="timeline-content">
																				<a href="#/" className="name">{edu.institute}</a>
																				<div>{edu.degree}</div>
																				<span className="time">{edu.year}</span>
																			</div>
																		</div>
																	</li>
																))
															}
														</ul>
													</div>
												</div>
											}
											{
												profile.doctorExperiences != undefined &&
												<div className="widget experience-widget">
													<h4 className="widget-title">Work & Experience</h4>
													<div className="experience-box">
														<ul className="experience-list">
															{
																profile.doctorExperiences != undefined &&
																profile.doctorExperiences.map(exp => (
																	<li>
																		<div className="experience-user">
																			<div className="before-circle"></div>
																		</div>
																		<div className="experience-content">
																			<div className="timeline-content">
																				<a href="#/" className="name">{exp.hospitalName}</a>
																				<span className="time">{exp.fromDate} - {exp.toDate ? exp.toDate : 'Present' } ({exp.toDate ? (exp.toDate - exp.fromDate) : ( (new Date()).getFullYear() - exp.fromDate ) } years) </span>
																			</div>
																		</div>
																	</li>
																))
															}
														</ul>
													</div>
												</div>
											}
											{
												profile.doctorAwards != undefined &&
												<div className="widget awards-widget">
													<h4 className="widget-title">Awards</h4>
													<div className="experience-box">
														<ul className="experience-list">
															{
																profile.doctorAwards != undefined &&
																profile.doctorAwards.map(a => (
																	<li>
																		<div className="experience-user">
																			<div className="before-circle"></div>
																		</div>
																		<div className="experience-content">
																			<div className="timeline-content">
																				<p className="exp-year">{a.month} {a.year}</p>
																				<h4 className="exp-title">{a.award}</h4>
																				<p>{a.description}</p>
																			</div>
																		</div>
																	</li>
																))
															}
														</ul>
													</div>
												</div>
											}
											{
												profile.doctorServices != undefined &&
												<div className="service-list">
													<h4>Services</h4>
													<ul className="clearfix">
														{
															profile.doctorServices != undefined &&
															profile.doctorServices.map(s => (
																<li>{s.service}</li>
															))
														}
													</ul>
												</div>
											}
											{
												profile.doctorSpecializations != undefined &&
												<div className="service-list">
													<h4>Specializations</h4>
													<ul className="clearfix">
														{
															profile.doctorSpecializations != undefined &&
															profile.doctorSpecializations.map(s => (
																<li>{s.specialization}</li>
															))
														}	
													</ul>
												</div>
											}
										</div>
									</div>
								</div>
								<div role="tabpanel" id="doc_locations" className="tab-pane fade">
									{
										profile.doctorClinic != undefined && 
										profile.doctorClinic.map( c => (
											<div className="location-list">
												<div className="row">
													<div className="col-md-6">
														<div className="clinic-content">
															<h4 className="clinic-name"><a href="#">{c.clinicName}</a></h4>
															<p className="doc-speciality">MDS - Periodontology and Oral Implantology, BDS</p>
															<div className="rating">
																<i className="fas fa-star filled"></i>
																<i className="fas fa-star filled"></i>
																<i className="fas fa-star filled"></i>
																<i className="fas fa-star filled"></i>
																<i className="fas fa-star"></i>
																<span className="d-inline-block average-rating">(4)</span>
															</div>
															<div className="clinic-details mb-0">
																<h5 className="clinic-direction"> <i className="fas fa-map-marker-alt"></i> {c.clinicAddress}<br /><a href="javascript:void(0);">Get Directions</a></h5>
																<ul>
																	<li>
																		<a href="assets/img/features/feature-01.jpg" data-fancybox="gallery2">
																			<img src="assets/img/features/feature-01.jpg" alt="Feature Image" />
																		</a>
																	</li>
																	<li>
																		<a href="assets/img/features/feature-02.jpg" data-fancybox="gallery2">
																			<img src="assets/img/features/feature-02.jpg" alt="Feature Image" />
																		</a>
																	</li>
																	<li>
																		<a href="assets/img/features/feature-03.jpg" data-fancybox="gallery2">
																			<img src="assets/img/features/feature-03.jpg" alt="Feature Image" />
																		</a>
																	</li>
																	<li>
																		<a href="assets/img/features/feature-04.jpg" data-fancybox="gallery2">
																			<img src="assets/img/features/feature-04.jpg" alt="Feature Image" />
																		</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<div className="col-md-4">
														<div className="clinic-timing">
															{
																c.clinicVisitingHr != undefined &&
																loadVisitingHrs(c.clinicVisitingHr)
															}
														</div>
													</div>
													<div className="col-md-2">
														<div className="consult-price">
															${c.charges}
														</div>
													</div>
												</div>
											</div>
										)) 	
									}
								</div>
								<div role="tabpanel" id="doc_reviews" className="tab-pane fade">
									<Reviews doctor={doctor} />
								</div>
								<div role="tabpanel" id="doc_business_hours" className="tab-pane fade">
									<div className="row">
										<div className="col-md-6 offset-md-3">
											<div className="widget business-widget">
												<div className="widget-content">
													<div className="listing-hours">
														<div className="listing-day current">
															<div className="day">Today <span>5 Nov 2019</span></div>
															<div className="time-items">
																<span className="open-status"><span className="badge bg-success-light">Open Now</span></span>
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Monday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Tuesday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Wednesday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Thursday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Friday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day">
															<div className="day">Saturday</div>
															<div className="time-items">
																<span className="time">07:00 AM - 09:00 PM</span>
															</div>
														</div>
														<div className="listing-day closed">
															<div className="day">Sunday</div>
															<div className="time-items">
																<span className="time"><span className="badge bg-danger-light">Closed</span></span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>		
        </div>
    );
}
 
export default DoctorProfile;